import { api, apiProvider } from '@/core/api/'

export default {
  getJournalInitFilters() {
    return apiProvider.get(`/api/beca/journalinitfilters`)
  },
  getStudentHasPaymentsForAcademicYear(properties) {
    return api.get(`/api/becas/academicYears/${properties.academicYearId}/students/${properties.studentSieId}/hasPayments`)
  },
}
